export enum TrafficReportAddressType {
  Include = 'Include',
  Exclude = 'Exclude',
}

export const trafficReportAddressTypeMap: Record<TrafficReportAddressType, string> = {
  [TrafficReportAddressType.Include]: 'Include',
  [TrafficReportAddressType.Exclude]: 'Exclude',
};

export const trafficReportAddressTypeOptions = [
  { value: TrafficReportAddressType.Include, label: trafficReportAddressTypeMap[TrafficReportAddressType.Include] },
  { value: TrafficReportAddressType.Exclude, label: trafficReportAddressTypeMap[TrafficReportAddressType.Exclude] },
];
